import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { COLLECTIONS, pageUrl } from "@/data/seoPages";

const resolve = (collection, slugs = []) =>
  slugs
    .map((s) => COLLECTIONS[collection].items.find((p) => p.slug === s))
    .filter(Boolean)
    .map((p) => ({ name: p.name, to: pageUrl(collection, p.slug) }));

/** Cross-links between services, sectors and locations for crawlers and visitors. */
export const RelatedLinks = ({ related = {} }) => {
  const groups = [
    { label: "Related services", links: resolve("services", related.services) },
    { label: "Sectors", links: resolve("sectors", related.sectors) },
    { label: "Also serving", links: resolve("locations", related.locations) },
  ].filter((g) => g.links.length);

  if (!groups.length) return null;

  return (
    <section data-testid="related-links" className="border-t hairline pt-10 mt-16 lg:mt-24 grid grid-cols-12 gap-y-8 sm:gap-x-8">
      {groups.map((g) => (
        <div key={g.label} className="col-span-12 sm:col-span-6 lg:col-span-4">
          <div className="overline mb-4">{g.label}</div>
          <ul className="space-y-2">
            {g.links.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="group inline-flex items-center gap-2 font-display text-xl lg:text-2xl tracking-tight hover:underline underline-offset-4 decoration-1"
                >
                  {l.name}
                  <ArrowUpRight size={16} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </section>
  );
};

export default RelatedLinks;
